// Re-export NotificationInbox as NotifBell for backward compatibility
import { NotificationInbox } from './NotificationInbox';
export default function NotifBell() {
  return <NotificationInbox />;
}
